import * as z from "zod";

const validationSchema = z.object({
  email: z
    .string({ message: "validation:emailRequired" })
    .max(100, { message: "validation:emailMaxLength" })
    .email({ message: "validation:emailFormatError" }),
});

export const LoginValidationSchema = validationSchema;
export type LoginFormInput = z.infer<typeof LoginValidationSchema>;
